import { Routes, Route, Outlet, Navigate, useLocation } from 'react-router-dom';
import { RaptorPublicRoutes, RaptorPrivateRoutes } from './raptor';
import { ErrorsRoutes, NoAccessRoutes } from './errors/errors.routes';
import { PrivateRoute, LayoutRoute } from '../guard/routes.guard';
import { LandingRouteService } from '../services/landing-route.service';
import NotFoundPublic from '../pages/errors/not-found-public.page';

const PrivateIndexRedirect = () => <Navigate to={LandingRouteService.getHomeRoute()} replace />;

/**
 * El correo de reset apunta a `${MAIL_PUBLIC_BASE_URL}/reset-password?token=...`,
 * sin el prefijo `/auth`. Redirigimos conservando el query string para que el
 * enlace funcione con cualquiera de las dos bases.
 */
const AuthAliasRedirect = ({ to }: { to: string }) => {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
};

export const AppRoutes = (
  <Routes>
    {/* Rutas públicas */}
    <Route path="/auth/*" element={<Outlet />}>
      {RaptorPublicRoutes}
    </Route>
    <Route path="/404-not-found" element={<NotFoundPublic />} />
    <Route path="/reset-password" element={<AuthAliasRedirect to="/auth/reset-password" />} />
    <Route path="/forgot-password" element={<AuthAliasRedirect to="/auth/forgot-password" />} />

    {/* Rutas privadas */}
    <Route path="/" element={<PrivateRoute />}>
      <Route path="/" element={<LayoutRoute />}>
        <Route index element={<PrivateIndexRedirect />} />
        {RaptorPrivateRoutes}
      </Route>
    </Route>

    {/* Rutas de error */}
    {ErrorsRoutes}
    {NoAccessRoutes}

    <Route path="*" element={<Navigate to="/auth/login" replace />} />
  </Routes>
);
